
import { defineComponent, PropType } from 'vue'
import { DEFAULT_COVER_IMAGE } from '@/utils/consts'
import { TemplateProps } from '@/store/templates'

export default defineComponent({
  name: 'TemplateList',
  props: {
    list: {
      type: Array as PropType<TemplateProps[]>,
      required: true
    }
  },
  setup() {
    return {
      DEFAULT_COVER_IMAGE
    }
  }
})
